import { cloudFunctionInstance } from 'core/config/axios'
import moment from 'moment'
// eslint-disable-next-line no-console
console.log(cloudFunctionInstance.defaults.baseURL)
export const getServerDate = async () => {
  const response = await cloudFunctionInstance.get('/getServerTimeV2')
  return new Date(response.data.datetime).setHours(0, 0, 0, 0)
}

export const getServerTime = async () => {
  const response = await cloudFunctionInstance.get('/getServerTimeV2')
  return new Date(response.data.datetime).getTime()
}

export const getServerDateAndTime = async (): Promise<{
  date: number
  time: number
}> => {
  const response = await cloudFunctionInstance.get('/getServerTimeV2')
  return {
    date: new Date(response.data.datetime).setHours(0, 0, 0, 0),
    time: moment(response.data.datetime).valueOf(),
  }
}
